import React from "react";
import { Link } from "react-router-dom";

function ProductContainer({ items = [] }) {
    return (
        <section id="breadcrumb" className="bg-white py-4 border-b">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center space-x-2 text-sm text-gray-600">
                    {items.map((item, idx) => (
                        <React.Fragment key={idx}>
                            {item.to ? (
                                <Link to={item.to} className="hover:text-brand-green">
                                    {item.label}
                                </Link>
                            ) : (
                                <span className="text-brand-green font-medium">
                  {item.label}
                </span>
                            )}

                            {idx < items.length - 1 && (
                                <i className="fa-solid fa-chevron-right text-xs"></i>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ProductContainer;
